import React from 'react'
import { func, bool } from 'prop-types'
import { Redirect, Route, withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import queryString from 'query-string'

import { loginViaToken } from '../actions'

const PrivateRoute = ({ component: Component, ...rest }) => {
  return (
    <Route {...rest} render={(props) => {
      if (rest.isAuth) {
        return <Component {...props} location={rest.location} />
      } else {
        let parsedQuery = queryString.parse(rest.location.search)
        let urlToGo = rest.location.pathname
        if (parsedQuery.itk) {
          rest.loginViaToken(parsedQuery.itk, urlToGo)
          return (
            <div className='container'>
              <h1>Carregando...</h1>
            </div>
          )
        } else {
          return <Redirect to={{ pathname: '/' }} />
        }
      }
    }} />
  )
}

PrivateRoute.propTypes = {
  component: func,
  isAuth: bool
}

const mapDispatchToProps = (dispatch) => {
  return {
    loginViaToken: (token, urlToGo) => {
      dispatch(loginViaToken(token, urlToGo))
    }
  }
}

const mapStateToProps = (state) => {
  return {
    isAuth: state.app.isAuth
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PrivateRoute))



// WEBPACK FOOTER //
// ./src/utils/PrivateRoute.js